import React, { useEffect, useState, Suspense, useMemo, lazy } from "react";
import Header from "./Header";
import { Footer } from "./Footer";
import { QuestionsList } from "../../../core/Model/QuestionsList";
import { InputsComponent } from "../../helpers/InputsComponent";
import { extraerNumeros } from "../../../utils/extraerNumeros";
import { Presentation } from "./Presentation";
import { Api } from "../../../core/Api";

import Loading from "../../helpers/Loading";
import AlertDialog from "../../helpers/Dialog";
import { NotAvailableComponent } from "../NotAvailableComponent";
import { SentComponent } from "../SentComponent";
import { useLocation } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { jsonPost } from "../../helpers/FormData";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
export const userContext = React.createContext();

export const FormComponent = ({
  nameEncuesta,
  guidIdEncuesta,
  isEncuestaGenerica,
}) => {
  const queryParams = new URLSearchParams(useLocation().search);
  const allQueryParams = Object.fromEntries(queryParams.entries());

  let encuestaNueva = process.env.REACT_APP_NAME_FORM;
  if (nameEncuesta) {
    encuestaNueva = nameEncuesta;
  }

  const [templateName, setTemplateName] = useState(null);

  document.title = `Encuesta ${encuestaNueva} ${new Date().getFullYear()}`;
  document.getElementById(
    "favicon"
  ).href = `../../assets/${encuestaNueva}/favIcon-${encuestaNueva}.png`;

  const Form = useMemo(() => {
    if (!templateName) return null;

    const formName = templateName;

    let formImport;

    switch (formName) {
        case "PickitPickers":
            formImport = import('./pickitpickers/FormPickitPickers');
            break;

        case "PickitPunto":
        case "PickitSeller":
        case "TiendaNube":
        case "PickitGeneric":
            formImport = import('./pickitgeneric/FormPickitGeneric');
            break;
            
        case "AndreaniEmbed":
             formImport = import('./andreaniembed/FormAndreaniEmbed'); 
             break;

        case "Andreani":
        case "Encuesta":
            formImport = import('./encuesta/FormEncuesta');
            break;

        default:
            const finalTemplateFolder = isEncuestaGenerica
                ? "encuesta"
                : formName.toLowerCase();
            const formComponentName = isEncuestaGenerica
                ? "Encuesta"
                : formName;

            formImport = import(
                `./${finalTemplateFolder}/Form${formComponentName}`
            ).catch(() => {
                return import('./encuesta/FormEncuesta');
            });
            break;
    }

    return React.lazy(() => formImport.catch((error) => {
        console.error(`Error al cargar la plantilla ${templateName}:`, error);
        return { default: NotAvailableComponent };
    }));

}, [templateName, isEncuestaGenerica]);


  const [loading, setLoading] = useState(false);
  const [question, setQuestion] = useState([]);
  const [error, setError] = useState("");
  const [state, setState] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [valueCatcha, setvalueCatcha] = useState("");
  const [msgAlert, setmsgAlert] = useState(false);
  const [showstars, setShowStars] = useState(false);
  const [enumera, setEnumera] = useState(false);
  const [showVersion, setShowVersion] = useState(true);
  const [slides, setSlides] = useState(null);
  const [preguntaXSlide, setPreguntaXSlide] = useState(null);
  const [showSendButton, setShowSendButton] = useState(true);
  const [parametrosURL, setParametrosURL] = useState(true);
  const [encuestaVigente, setEncuestaVigente] = useState(null);
  const [canal, setCanal] = useState(allQueryParams.canal);
  const [cliente, setCliente] = useState(allQueryParams.cliente?.toLowerCase());
  const [maxChars, setMaxChars] = useState(0);
  const [showTextCounter, setShowTextCounter] = useState(true);
  const [alertCaptcha, setAlertCaptcha] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const cod = allQueryParams.cod;
  const testVisitor = allQueryParams.testVisitor;
  const categoria = allQueryParams.categoria?.toLowerCase();

  const [visitorId, setVisitorId] = useState(null);

  useEffect(() => {
    getVisitorId();
  }, []);

  useEffect(() => {
    if (alertCaptcha) {
      setmsgAlert(false);
    } else {
      setmsgAlert(true);
    }
  }, [alertCaptcha]);

  useEffect(() => {
    const urlSolicitante = window.location.href;

    const getQuestions = async () => {
      const pvisitorId = await getVisitorId();
      allQueryParams.visitorId = testVisitor ? numeroRandom(1, 10) : pvisitorId;
      allQueryParams.guidIdEncuesta = guidIdEncuesta;
      allQueryParams.urlSolicitante = urlSolicitante;
      setLoading(true);
      QuestionsList.getQuestions(allQueryParams)
        .then((res) => {
          const template = res.nombrePlantilla || encuestaNueva;
          setTemplateName(template); 
          
          setSlides(res.slides);
          setPreguntaXSlide(res.pregXSlide);
          localStorage.setItem("Messages", JSON.stringify(res.messagesList));
          localStorage.setItem("Images", JSON.stringify(res.imagesList));

          setQuestion(res.questions);
          setShowTextCounter(res.mostarContadorTexto);
          setMaxChars(res.maxCaracteresTexto);
          setLoading(false);
          setShowCaptcha(res.status);
          setEncuestaVigente(res.encuestaVigente);
          setParametrosURL(res.parametrosURL);
          setShowStars(res.showStars);
          setEnumera(res.enumera);
          if (res.slides) setShowSendButton(false);
        })
        .catch((err) => {
          setError(err);
          setTemplateName(encuestaNueva); 
          localStorage.setItem("Messages", JSON.stringify(err.messagesList));
          localStorage.setItem("Images", JSON.stringify(err.imagesList));
        });
    };

    getQuestions();
  }, []);

  const getVisitorId = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    setVisitorId(result.visitorId);
    return result.visitorId;
  };

  const SetResponsesValues = (e) => {
    e.preventDefault();
    setShowAlert(false);
    validForm({ responses: jsonPost(e), cod: cod });
  };
  
  const buildUrlWithParams = (baseUrl, params) => {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ""
      )
    );

    const queryString = new URLSearchParams(filteredParams).toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
  };

  const validForm = (formData) => {
    const { responses } = formData;
    let flag = false;

    responses.forEach((item) => {
      item.IdRespuesta = extraerNumeros(item.IdRespuesta);
    });

    question.forEach((q) => {
      if (
        q.PreguntaObligatoria && 
        !responses.some((res) => q.PreguntaId == res.IdPregunta)
      ) {
        const objFiltered = question.filter((q) => q.PreguntaIdPadre != 0);

        if (objFiltered.every((obj) => q.PreguntaId != obj.PreguntaId)) {
          console.log("preguntaid:", q.PreguntaId)
          flag = true;
          setmsgAlert(true);
          setAlertCaptcha(false);
        } else {
          if (responses.some((res) => q.PreguntaId == res.subPreguntaId)) {
            console.log("preguntaid2:", q.PreguntaId)
            flag = true;
            setmsgAlert(true);
            setAlertCaptcha(false);
          } else {
            //flag = false;
          }
        }
      }
    });

    if (showCaptcha && valueCatcha === "" && flag === false) {
      flag = true;
      setAlertCaptcha(true);
    }

    setShowAlert(flag);

    if (flag === false) {
      const urlSolicitante = window.location.href;

      setLoading(true);

      allQueryParams.visitorId = testVisitor ? numeroRandom(1, 10) : visitorId;
      allQueryParams.guidIdEncuesta = guidIdEncuesta;
      allQueryParams.urlSolicitante = urlSolicitante;

      let path = buildUrlWithParams("/responses", allQueryParams);

      Api.post(path, formData)
        .then(async (res) => {
          const { success, error } = await res.json();

          if (error) {
            setError({
              errMsj: error["message"],
              intCod: error["cod"],
              imagesList: error["images"],
              messagesList: error["messages"],
            });
          } else {
            setState(res["ok"]);
          }

          setTimeout(() => {
            setLoading(false);
          }, 3000);
        })
        .catch((err) => {
          setLoading(false);
        });
      setShowVersion(false);
    }
  };

  function numeroRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const onChange = (value) => {
    setvalueCatcha(value);
  };

  if (encuestaVigente || encuestaVigente === null) {
    return (
      <userContext.Provider
        value={{
          enumera,
          question,
          setEnumera,
          showstars,
          showVersion,
          slides,
          preguntaXSlide,
          setShowSendButton,
          showSendButton,
          currentPage,
          msgAlert,
          canal,
          setCurrentPage,
          setAlertCaptcha,
          maxChars,
          showCaptcha,
          valueCatcha,
          showAlert,
          showTextCounter,
          setShowAlert,
          setmsgAlert,
          parametrosURL,
        }}
      >
        <div>
          <Suspense fallback={<Loading />}>
            {Form ? (
              <Form
                error={error}
                SetResponsesValues={SetResponsesValues}
                question={question}
                showCaptcha={showCaptcha}
                msgAlert={msgAlert}
                state={state}
                loading={loading}
                onChange={onChange}
                showAlert={showAlert}
                setShowAlert={setShowAlert}
                showSendButton={showSendButton}
                alertCaptcha={alertCaptcha}
                slider={slides}
                showTextCounter={showTextCounter}
                canal={canal}
                cliente={cliente}
                encuestaNueva={encuestaNueva}
              />
            ) : (
                <Loading />
            )}
          </Suspense>
        </div>
      </userContext.Provider>
    );
  } else {
    setTimeout(() => {
      return (
        <div style={{ textAlign: "center" }}>
          <h1>La encuesta no se encuentra vigente</h1>
        </div>
      );
    }, 500);
  }
};